// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","description":"Header_description__XjttN"};